export const POSTGRES_INTEGER_MAX = 2147483647;
export const INVALID_ORDER_ID_MESSAGE = 'Order ID no valido, escanea nuevamente';

export function normalizeOrderId(value) {
    const normalized = String(value ?? '').trim();
    if (!/^[0-9]+$/.test(normalized)) {
        throw new Error(INVALID_ORDER_ID_MESSAGE);
    }

    const parsed = Number(normalized);
    if (!Number.isSafeInteger(parsed) || parsed <= 0 || parsed > POSTGRES_INTEGER_MAX) {
        throw new Error(INVALID_ORDER_ID_MESSAGE);
    }

    return normalized;
}

export function createScanRequestGate() {
    let pending = false;
    return {
        tryStart() {
            if (pending) return false;
            pending = true;
            return true;
        },
        finish() { pending = false; },
        isPending() { return pending; },
    };
}
